import {createApp} from 'vue/dist/vue.esm-browser.prod';
import {get} from "../partials/data-manager";
import docCookies from 'doc-cookies';
import Animate from "../partials/animate";

export default class ProductList {
    constructor($el) {
        this.$el = $el;
        this.createVueApp();
    }

    createVueApp() {
        const blockId = this.$el.dataset.blockId;
        const productList = this.$el.querySelector('[data-product-list]');
        const container = this.$el;

        const app = createApp({
            data() {
                return {
                    blockId: blockId,
                    page: 1,
                    products: [],
                    totalCount: '',
                    allCount: '',
                    loader : null,
                    count : null,
                    pager: null,
                    loading: null,
                    productList: productList,
                    brand: null,
                    container: container,
                    isLoaded: false,
                    category: null,
                    sort: '',
                    nameSort: null,
                    filter: '',
                    isInitialLoad: true,
                    animals: [],
                    brands: [],
                    categoryCounts: {},
                    brandCounts: {},
                    publicationId: 0,
                    publication: null
                };
            },
            computed: {
                activeBrand() {
                    if (!this.brand) {
                        return null;
                    }

                    return this.brands.find((brand) => brand.code === this.brand) || null;
                },
                activeBrandLabel() {
                    return this.activeBrand ? this.activeBrand.label : null;
                },
            },
            methods: {

                /**
                 * Set page
                 * @param page
                 */
                setPage(page) {
                    this.page = page;
                    this.$nextTick(() => {
                        this.fetchProducts();
                    });
                },


                /**
                 * Get Filters
                 * We get the filters by serializing the form and stripping the empty filters
                 * @returns {{[p: string]: any}}
                 */
                getFilters() {
                    const formData = this.$refs.filters ? new FormData(this.$refs.filters) : new FormData();
                    let filters = {
                        ...Object.fromEntries(formData),
                        page: this.page,
                        brand: this.brand,
                        nameSort: this.nameSort,
                    };

                    filters = Object.fromEntries(
                        Object.entries(filters).filter(
                            ([filter, value ]) => {
                                if (value) {
                                    return [filter, value];
                                }
                            }
                        )
                    );

                    return filters;
                },
                /**
                 * Set the current filters in the url
                 * @param filters
                 */
                setFiltersInUrl(filters) {
                    const url = new URL(window.location.href);
                    url.search = (new URLSearchParams(filters)).toString();

                    window.history.pushState({},"", url.toString())
                },
                /**
                 * Set filters by the active url
                 */
                getFiltersByUrl() {
                    const params = (new URLSearchParams(window.location.search));

                    if (params.has('page')) {
                        this.page = parseInt(params.get('page'));
                    }

                    if (params.has('brand')) {
                        this.brand = params.get('brand');
                    }

                    if (params.has('nameSort')) {
                        this.nameSort = params.get('nameSort');
                    }
                },
                /**
                 * Set the current filters in the cookie
                 * @param filters
                 */
                setFiltersInCookie(filters) {
                    const expiryDate = new Date(Date.now() + 5 * 60 * 1000);
                    docCookies.setItem('product-list-filters', JSON.stringify(filters), expiryDate)
                },
                /**
                 * Check if we have previous filters in a cookie
                 * If so we use them as the starting default
                 */
                getFiltersFromCookie() {
                    const filters = JSON.parse(docCookies.getItem('product-list-filters'));

                    if(! filters) {
                        return;
                    }

                    // if (filters.page) {
                    //     this.page = parseInt(filters.page);
                    // }
                    //

                    if (filters.brand) {
                        this.brand = filters.brand;
                    }
                    //
                    // if (filters.nameSort) {
                    //     this.nameSort = filters.nameSort;
                    // }
                },
                /**
                 * Get the product data
                 * @returns {Promise<void>}
                 */
                async fetchProducts() {
                    const params = this.getFilters();
                    this.setFiltersInUrl(params);
                    this.setFiltersInCookie(params);

                    const url = `${currentHref}/block/${blockId}/ajax`;

                    if (this.abortController) {
                        this.abortController.abort();
                    }

                    this.loading = true;

                    this.abortController = new AbortController();
                    const result = await get(url, params, this.abortController.signal);


                    if( ! result) {
                        return;
                    }
                    // Set the values we need
                    this.products = result.publications;
                    this.pager = result.pager;
                    this.animals = result.animals;
                    this.brands = result.brands || [];
                    const invalidBrandCleared = this.clearInvalidBrand();
                    this.categoryCounts = result.categoryCounts || {};
                    this.brandCounts = result.brandCounts || {};
                    this.publication = result.publication;
                    this.publicationId = result.publication ? result.publication.id : 0;

                    if (invalidBrandCleared) {
                        const filters = this.getFilters();
                        this.setFiltersInUrl(filters);
                        this.setFiltersInCookie(filters);
                    }

                    this.loading = false;

                    this.totalCount = result.totalCount;
                    this.allCount = result.allCount;

                    this.makePager();

                    this.$nextTick(() => {
                        window.initDom(this.$refs.products || this.$el);
                        this.scrollToProducts();
                    });

                },
                makePager() {
                    let numberOfItems = this.pager.numberOfPages;
                    let page = this.page;
                    let pageStart = page > 2? page - 1 : 1;
                    let pageEnd = this.page + 1;
                    let pages = [];

                    if (pageEnd < numberOfItems)
                    {
                        for(let x = pageStart; x<= pageEnd; x++)
                        {
                            pages.push(x);
                        }
                    }else {
                        for(let x = pageStart ; x<= numberOfItems; x++)
                        {
                            pages.push(x);
                        }
                    }

                    if(screen.width > 992)
                    {
                        if(pages[0] !== 1){
                            pages.unshift('...');
                            pages.unshift(1);
                        }

                        if(pages[pages.length - 1] !== numberOfItems)
                        {
                            pages.push('...');
                            pages.push(numberOfItems)
                        }
                    }

                    this.pages = pages;
                },
                toggleCollapse(e) {
                    e.preventDefault();
                    const top = e.currentTarget;
                    const parent = top.closest('[data-collapsable]');
                    const body = parent ? parent.querySelector('[data-collapsable-body]') : null;

                    if (!body) {
                        return;
                    }

                    top.classList.toggle('collapsable__item__top--open');
                    body.classList.toggle('collapsable__item__text--open');
                    const isOpen = top.classList.contains('collapsable__item__top--open');
                    const label = isOpen ? top.dataset.labelClose : top.dataset.labelOpen;

                    top.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    body.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

                    if (label) {
                        top.setAttribute('aria-label', label);
                        top.setAttribute('title', label);
                    }

                },
                closeCollapse(e) {
                    e.preventDefault();
                    const top = e.currentTarget;
                    const parent = top.closest('[data-collapsable]');
                    const body = parent ? parent.querySelector('[data-collapsable-body]') : null;

                    if (!body) {
                        return;
                    }

                    top.classList.remove('collapsable__item__top--open');
                    body.classList.remove('collapsable__item__text--open');
                    top.setAttribute('aria-expanded', 'false');
                    body.setAttribute('aria-hidden', 'true');

                    if (top.dataset.labelOpen) {
                        top.setAttribute('aria-label', top.dataset.labelOpen);
                        top.setAttribute('title', top.dataset.labelOpen);
                    }

                    top.focus();
                },
                filterBrand(brandCode) {
                    this.brand = brandCode;
                    this.page = 1;
                    this.fetchProducts();
                },
                checkActiveBrand()
                {
                    if( ! this.activeBrand) {
                        return;
                    }
                    this.openCollapse(this.$refs.brandCollapse);
                },
                removeFilterBrand(e = null)
                {
                    if (e) {
                        e.preventDefault();
                    }

                    this.brand = null;
                    this.page = 1;
                    this.fetchProducts();
                },
                clearInvalidBrand() {
                    if (!this.brand) {
                        return false;
                    }

                    const brandExists = this.brands.some((brand) => brand.code === this.brand);

                    if (brandExists) {
                        return false;
                    }

                    this.brand = null;

                    return true;
                },
                openCollapse(collapse) {
                    if (!collapse) {
                        return;
                    }

                    var top = collapse.querySelector('[data-collapsable-top]');
                    var body = collapse.querySelector('[data-collapsable-body]');

                    if( ! top || ! body) {
                        return;
                    }

                    top.classList.add('collapsable__item__top--open');
                    body.classList.add('collapsable__item__text--open');
                    top.setAttribute('aria-expanded', 'true');
                    body.setAttribute('aria-hidden', 'false');

                    if (top.dataset.labelClose) {
                        top.setAttribute('aria-label', top.dataset.labelClose);
                        top.setAttribute('title', top.dataset.labelClose);
                    }
                },
                changeFilter() {
                    switch(this.filter) {
                        case '':
                            this.toggleNameSorting('reset');
                            break;
                        case 'ASC':
                            this.toggleNameSorting('ASC');
                            break;
                        case 'DESC':
                            this.toggleNameSorting('DESC');
                            break;
                    }
                },
                /**
                 * Toggle sorting on name
                 */
                toggleNameSorting(value) {
                    if(value === 'reset')
                    {
                        this.nameSort = null;
                        this.sort = null;
                        this.$nextTick(this.fetchProducts);
                    }else {
                        this.nameSort = value;
                        this.sort = null;
                        this.$nextTick(this.fetchProducts);
                    }

                },
                checkActiveFilter()
                {
                    if( ! this.nameSort) {
                        return;
                    }

                    this.filter = this.nameSort;
                },
                scrollToProducts() {
                    const delay = this.isInitialLoad ? 350 : 100;

                    setTimeout(() => {
                        let element = this.$refs.products || this.container || this.$el;

                        if (Array.isArray(element)) {
                            element = element[0];
                        }

                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        } else {
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }

                        this.isInitialLoad = false;
                    }, delay);
                },
                /**
                 * Check of een categorie/item de actieve pagina is
                 * @param {Object} item
                 * @returns {boolean}
                 */
                isCategoryActive(item) {
                    if (!item) return false;
                    // Gebruik de ID die uit je API/state komt (pas 'currentPublicationId' aan naar jouw variabele)
                    return this.publicationId === item.id;
                },

                /**
                 * Check of een van de kinderen van de categorie actief is
                 * @param {Object} animal
                 * @returns {boolean}
                 */
                isCategoryChildActive(animal) {
                    if (!animal || !animal.children || !animal.children.length) return false;
                    return animal.children.some(child => this.isCategoryActive(child));
                },

                /**
                 * Bepaal of het dier-menu uitgeklapt moet worden
                 * @param {Object} animal
                 * @returns {boolean}
                 */
                isCategoryExpanded(animal) {
                    return this.isCategoryActive(animal) || this.isCategoryChildActive(animal);
                },

                /**
                 * Check of een dier subcategorieën heeft
                 * @param {Object} animal
                 * @returns {boolean}
                 */
                hasCategoryChildren(animal) {
                    return Array.isArray(animal.children) && animal.children.length > 0;
                },
                getCategoryCount(categoryId) {
                    return this.categoryCounts[categoryId] ?? 0;
                },
                getBrandCount(brandId) {
                    return this.brandCounts[brandId] ?? 0;
                },
            },
            async mounted() {
                await this.fetchProducts();
                this.initialized = true;

                container.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));

                this.checkActiveBrand();
                this.checkActiveFilter();
                this.isLoaded = true;

            },
            created() {
                if (window.location.search) {
                    this.getFiltersByUrl();
                } else {
                    this.getFiltersFromCookie();
                }
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$el);
    }
}
